export default {
  SET_TOP_FILTERS: (state, { list, type }) => {
    state.topFilters[type] = list;
  },
};
